import React from 'react';
import { DEFAULT_CONTEXT_VALUES } from 'common/constants';

export default React.createContext(DEFAULT_CONTEXT_VALUES);
